import { useCallback } from 'react';
import axios from 'axios';

export interface ActivityLogData {
  type: 'user' | 'post' | 'contact' | 'settings' | 'backup' | 'login' | 'error';
  action: string;
  description: string;
  metadata?: any;
}

export const useActivityLogger = () => {
  const logActivity = useCallback(async (data: ActivityLogData) => {
    try {
      await axios.post('/activities', data);
    } catch (error) {
      console.error('Erro ao registrar atividade:', error);
      // Não falhar a operação principal por causa do log
    }
  }, []);

  const logUserActivity = useCallback((action: string, description: string, metadata?: any) => {
    logActivity({
      type: 'user',
      action,
      description,
      metadata
    });
  }, [logActivity]);

  const logPostActivity = useCallback((action: string, description: string, metadata?: any) => {
    logActivity({
      type: 'post',
      action,
      description,
      metadata
    });
  }, [logActivity]);

  const logContactActivity = useCallback((action: string, description: string, metadata?: any) => {
    logActivity({
      type: 'contact',
      action,
      description,
      metadata
    });
  }, [logActivity]);

  const logSettingsActivity = useCallback((action: string, description: string, metadata?: any) => {
    logActivity({
      type: 'settings',
      action,
      description,
      metadata
    });
  }, [logActivity]);

  const logSystemActivity = useCallback((action: string, description: string, metadata?: any) => {
    logActivity({
      type: 'backup',
      action,
      description,
      metadata
    });
  }, [logActivity]);

  return {
    logActivity,
    logUserActivity,
    logPostActivity,
    logContactActivity,
    logSettingsActivity,
    logSystemActivity
  };
};

export default useActivityLogger;
